module.exports = __webpack_public_path__ + "static/media/flipkart.ab4ffbd1.png";